<template>
  <component :is="displayAsFooter ? 'footer' : 'div'">
    <nav class="legal-links" role="footer">
      <ul class="footer-bar">
        <li>
          <router-link to="/terms">{{ $t("Terms") }}</router-link>
        </li>
        <li>
          <router-link to="/privacy">{{ $t("Privacy") }}</router-link>
        </li>
        <li>
          <router-link to="/accessibility">{{ $t("Accessibility") }}</router-link>
        </li>
      </ul>
    </nav>
  </component>
</template>

<script>
export default {
  name: "FooterLinks",
  props: {
    displayAsFooter: {
      type: Boolean,
      default: true // Default behavior is to wrap in <footer>
    }
  }
};
</script>

<style lang="stylus" scoped>
/*
footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin-left: 220px;
  border-top: 1px solid #e0e0e0;
  height: 49px;
  padding: 0 1em;
  box-sizing: border-box;
  display: flex;
  background: white;
}
footer .v-list {
  display: flex;
  flex-direction: row;
  gap: .5em;
  padding: 0;
}
*/

nav.legal-links {
  display: block;
  margin: 2rem;
  border-top : 2px solid #1c7db7;
  padding: .5rem 20vw;
  width: 100vw;
  position: absolute;
  left: 0;
  margin: 0 0 1rem 0;
  font-size: .9rem;
}

nav.legal-links ul {
  padding: 0;
  list-style-type: none;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  word-break: break-word;
  white-space: break-spaces;
  word-spacing: normal;
}

nav.legal-links ul li {
  margin: 0 .5rem 0 .5rem;
  list-style-type: none;
  padding: .5rem .5rem;
}
nav.legal-links a {
  color: #0758a6 !important;
}

@media screen and (max-width: 780px) {
  nav.legal-links ul li {
    margin: 0;
    list-style-type: none;
    padding: 0.5rem 0;
    text-align: center;
    line-height: 1.2;
  }
}
</style>
